window.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('#StickyCart');
  const btn    = document.querySelector('button[name="add"]');
  const footer = document.querySelector('footer');
  const body   = document.body;

  let footerVisible = false;
  let buttonOffTop  = false;

  function updateSticky() {
    if (buttonOffTop && !footerVisible) {
      sticky.classList.add('show');
      body.classList.add('has-sticky-cart');
    } else {
      sticky.classList.remove('show');
      body.classList.remove('has-sticky-cart');
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === btn) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          buttonOffTop = true;
        } else {
          buttonOffTop = false;
        }
      }
      if (entry.target === footer) {
        footerVisible = entry.isIntersecting;
      }
    });
    updateSticky();
  }, {
    threshold: 0
  });

  observer.observe(btn);
  observer.observe(footer);

  updateSticky();

  const img = sticky.querySelector('.product-content img');
  const selectField = sticky.querySelector('select[name="id"]');

  if (selectField) {
    selectField.addEventListener('change', () => {
      img.setAttribute('src', selectField.options[selectField.selectedIndex].dataset.img);
    });
  }

  document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);

    if (value) {
      selectField.value = value
    }
  })
});